import $ from 'jquery'
import CONSTS from '../constants'
import Component from './component'

export class SideNavigation extends Component {
  constructor(ctx, ev) {
    super(ctx, ev)

    Object.assign(this.classes, {
      btnClose: '.js-sidenavi-btn-close',
      topNaviRightItemActive:
        '.m-top-navigation__menu2__item__right.h-state--active',
    })

    Object.assign(this.classStates, {
      sidenaviOpen: 'h-state--sidenavi-open',
    })

    this.active = false
    this.leftNegative = '-120%'

    this.$body = $('body')
    this.$btnClose = this.$ctx.find(this.classes.btnClose)

    this.bindEvents()
    this.bindBtnClose()
    this.bindEsc()
  }

  bindEvents() {
    this.ev.on(CONSTS.EVENTS.OPEN_SIDE_NAVI, () => this.toggle('open'))
  }

  bindBtnClose() {
    this.$btnClose.on('click', (event) => {
      event.preventDefault()
      this.toggle('close')
    })
  }

  bindEsc() {
    $(document).on(`keydown.${this.constructor.name}`, (event) => {
      const RADIX = 10
      const KEY_ESCAPE = 27

      if (window.parseInt(event.which, RADIX) === KEY_ESCAPE && this.active) {
        // dont do anything if TopNavigationSidebar
        // form is active
        const $rightItemActive = this.$ctx.find(
          this.classes.topNaviRightItemActive
        )

        if ($rightItemActive.length === 0) {
          this.toggle('close')
        }
      }
    })
  }

  toggle(action) {
    if (action === 'open') {
      this.$ctx.animate(
        {
          left: 0,
        },
        this.durations.animationInSideNavi,
        () => {
          this.active = true
          this.$body.addClass(this.classStates.sidenaviOpen)
        }
      )
    } else if (action === 'close') {
      this.$ctx.animate(
        {
          left: this.leftNegative,
        },
        this.durations.animationOutSideNavi,
        () => {
          this.active = false
          this.$body.removeClass(this.classStates.sidenaviOpen)
        }
      )
    }
  }

  onResize(winWidth) {
    if (winWidth > CONSTS.MOBILE_WIDTH) {
      this.active = false
      this.$body.removeClass(this.classStates.sidenaviOpen)
    } else {
      this.leftNegative = '-120%'
    }

    if (this.active) {
      this.$ctx.css({
        left: 0,
      })
    } else {
      this.$ctx.css({
        left: this.leftNegative,
      })
    }
  }
}
